export default {
  attachment: `profile/attachments`,
  update: `profile/attachments/update`,
  remove: `profile/attachments/remove`,
};
